import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { NovedadesLayerContent } from '../components/novedades-layer-content';
import { useNovedadesCardClick } from './use-novedades-card-click';
import { useNovedadesTracker } from '../helpers/use-novedades-tracker';
import { NovedadesItem } from '@esportal/portal-service';
import { IContextNovedades } from '../models/context-novedades';

interface UseNovedadesLayerProps {
	item: NovedadesItem;
	context: React.Context<IContextNovedades>;
}

export const useNovedadesLayer = ({ item, context }: UseNovedadesLayerProps) => {
	const itemId = item.layer.title ?? item.id;
	const itemCtaLabel = item.card.cta.label ?? 'Descubre más';

	const { layerManager } = useContext(context);
	const { trackOpenLayerClick, trackLayerLoad, trackLayerCloseClick } = useNovedadesTracker({
		itemId: itemId.toString(),
	});

	const [isLayerOpen, setIsLayerOpen] = useState(false);

	const handleOnClick = useNovedadesCardClick({ item, context });

	const handleLayerOpen = () => {
		trackOpenLayerClick(itemCtaLabel);
		setIsLayerOpen(true);
	};

	useEffect(() => {
		if (isLayerOpen) {
			trackLayerLoad();
		}
	}, [isLayerOpen, trackLayerLoad]);

	const handleLayerClose = useCallback(() => {
		setIsLayerOpen(false);
		trackLayerCloseClick();
	}, [trackLayerCloseClick]);

	useEffect(() => {
		if (!isLayerOpen) return;

		const layer = layerManager.openContentLayerV2(
			() => <NovedadesLayerContent item={item} onCtaClick={handleOnClick} />,
			{},
			{
				shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				closeButtonLabel: 'Close Video Layer',
				contentHeadline: item.card.title ?? '',
				onClose: handleLayerClose,
			},
		);

		return () => {
			layer.close();
		};
	}, [isLayerOpen, layerManager, item, handleLayerClose, handleOnClick]);

	return {
		handleLayerOpen,
	};
};
